import {Marker} from "react-leaflet";

function getIcon(icon, color, selectedColor, selected){
    return L.divIcon({
        html: '<span  class="fa-stack fa-2x" style="vertical-align: top;">\n' +
            '        <i style="color:'+ (selected ? selectedColor :  color )+'" class="fa fa-map-marker fa-stack-2x"></i>\n' +
            '        <i style="color:white;" class="inner-icon fas '+icon+' fa-stack-1x"></i>\n' +
            '</span>',
        iconSize: [60, 48],
        iconAnchor:   [30, 48],
    });
}

export const StepMarker = ({selected, color = '#454fc8', selectedColor, ...props }) => {
    let icon =  L.divIcon({
        html: '<i style="color:'+ (selected ? selectedColor :  color )+'" class="fa fa-2x fa-map-marker-alt" aria-hidden="true"></i>',
        iconSize: [18, 24],
        iconAnchor:   [9, 24],
    });
    return <Marker zIndexOffset={selected ? 1000 : 0} {...props}  icon={icon} />
}

export const HikerMarker = ({selected, ...props }) => {
    return <Marker zIndexOffset={selected ? 1000 : 0} {...props}  icon={getIcon('fa-hiking', '#dc602c', '#0d5aa7', selected)} />
}

export const LodgingMarker = ({selected, color = '#44414a', selectedColor = '#0d5aa7', ...props }) => {
    return <Marker zIndexOffset={selected ? 1000 : 0} {...props}  icon={getIcon('fa-bed', color, selectedColor, selected)} />
}

export const PharmacyMarker = ({selected, ...props }) => {
    return <Marker zIndexOffset={selected ? 1000 : 0} {...props}  icon={getIcon('fa-clinic-medical', '#5cb85c', '#0d5aa7', selected)} />
}

export const BakeryMarker = ({selected, ...props }) => {
    return <Marker zIndexOffset={selected ? 1000 : 0} {...props}  icon={getIcon('fa-croissant', '#f0ad4e', '#0d5aa7', selected)} />
}

export const SupermarketMarker = ({selected, ...props }) => {
    return <Marker zIndexOffset={selected ? 1000 : 0} {...props}  icon={getIcon('fa-apple-alt', '#d9534f', '#0d5aa7', selected)} />
}

export const CarParkingMarker = ({selected, ...props }) => {
    return <Marker zIndexOffset={selected ? 1000 : 0} {...props}  icon={getIcon('fa-car', '#fd5f15', '#fd5f15', selected)} />
}

export const DepartureMarker = ({selected, ...props }) => {
    return <Marker zIndexOffset={selected ? 1000 : 0} {...props}  icon={getIcon('fa-play', '#fd5f15', '#fd5f15', selected)} />
}

export const ArrivalMarker = ({selected, ...props }) => {
    return <Marker zIndexOffset={selected ? 1000 : 0} {...props}  icon={getIcon('fa-stop', '#fd5f15', '#fd5f15', selected)} />
}

export const CollectionMarker = ({selected, ...props }) => {
    return <Marker zIndexOffset={selected ? 1000 : 0} {...props}  icon={getIcon('fa-garage-car', '#fd5f15', '#fd5f15', selected)} />
}

export const DepositMarker = ({selected, ...props }) => {
    return <Marker zIndexOffset={selected ? 1000 : 0} {...props}  icon={getIcon('fa-car', '#fd5f15', '#fd5f15', selected)} />
}

export const BikeMarker = ({selected, ...props }) => {
    return <Marker zIndexOffset={selected ? 1000 : 0} {...props}  icon={getIcon('fa-bicycle', '#fd5f15', '#fd5f15', selected)} />
}